import { render, staticRenderFns } from "./RecursiveDocumentsCategory.vue?vue&type=template&id=b505764e"
import script from "./RecursiveDocumentsCategory.vue?vue&type=script&lang=js"
export * from "./RecursiveDocumentsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports